import { s3PresignedQuoteUrl, updateQuoteImage, s3PresignedArticleUrl, updateArticleImage } from "../api";

export const useImageRetrieveUrl = () => {

    const uploadQuoteImage = async (file, existingUuid) => {
        const ext = file.type.split("/").pop();
        const { imageQuoteUrl, thumbnailImageUrl } = await s3PresignedQuoteUrl(ext, existingUuid);
        const { url, uuid } = imageQuoteUrl;
        const imageUrl = url.split("?")[0];
        const thumbnailUrl = thumbnailImageUrl.url.split("?")[0];
        await updateQuoteImage(url, file);
        return { imageUrl, thumbnailUrl, uuid };
    };

    const uploadArticleImage = async (file, existingUuid) => {
        const ext = file.type.split("/").pop();
        const { url } = await s3PresignedArticleUrl(ext, existingUuid);
        const imageUrl = url.split("?")[0];
        await updateArticleImage(url, file);
        return imageUrl;
    };

    return { uploadQuoteImage, uploadArticleImage };
};
